import './App.css';
import Login from './components/auths/Login';
import MainLayout from './components/partials/layouts/MainLayout';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';



function App() {
  return (
    <Router>
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/main-layout" element={<div><MainLayout /></div>} />
        </Routes>
    </Router>
  );
}

export default App;
